import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useClient } from "../../common/ClientProvider";
import { MemberMetricsService } from "./MemberMetricsService";

interface MemberMetricsServiceProviderProps {
  children: React.ReactNode;
}

export const MemberMetricsServiceContext = React.createContext<
  MemberMetricsService | undefined
>(undefined);

export const MemberMetricsServiceProvider: React.FC<
  MemberMetricsServiceProviderProps
> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { currentClientId } = useClient();

  const service = React.useMemo(() => {
    return new MemberMetricsService(getAccessTokenSilently, currentClientId);
  }, [getAccessTokenSilently, currentClientId]);

  return (
    <MemberMetricsServiceContext.Provider value={service}>
      {children}
    </MemberMetricsServiceContext.Provider>
  );
};

export const useMemberMetricsService = (): MemberMetricsService => {
  const context = React.useContext(MemberMetricsServiceContext);
  if (context === undefined) {
    throw new Error(
      "useMemberMetricsService must be used within a MemberMetricsServiceProvider"
    );
  }
  return context;
};
